import { render, staticRenderFns } from "./procedure1.vue?vue&type=template&id=6ccd6ab4&scoped=true"
import script from "./procedure1.vue?vue&type=script&lang=js"
export * from "./procedure1.vue?vue&type=script&lang=js"
import style0 from "./procedure1.vue?vue&type=style&index=0&id=6ccd6ab4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ccd6ab4",
  null
  
)

export default component.exports